export const VDC = 'VDC'